import { useEffect } from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "app/theme/theme";
import LandingHeader from "features/landing/components/LandingHeader";
import LandingFooter from "features/landing/components/LandingFooter";
import HeroSection from "features/landing/components/HeroSection";
import FeaturesSection from "features/landing/components/FeaturesSection";
import ContactSection from "features/landing/components/ContactSection";
import { getCategories } from "features/planner/api/exerciseApi";

export default function LandingPage() {
  useEffect(() => {
    getCategories().catch(() => undefined);
  }, []);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Gymplanner · Crea rutinas en minutos";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        lang="es"
        sx={{
          minWidth: 0,
          "& a:focus-visible": { outlineColor: "accent.main" },
          "@media (prefers-reduced-motion: reduce)": {
            "& *, & *::before, & *::after": {
              transition: "none !important",
              animation: "none !important",
            },
          },
        }}
      >
        <LandingHeader />
        <Box component="main">
          <HeroSection />
          <FeaturesSection />
          <ContactSection />
        </Box>
        <LandingFooter />
      </Box>
    </ThemeProvider>
  );
}
